import { render, staticRenderFns } from "./ExhibitionBaseDetail.vue?vue&type=template&id=f344eb28&scoped=true&"
import script from "./ExhibitionBaseDetail.vue?vue&type=script&lang=js&"
export * from "./ExhibitionBaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionBaseDetail.vue?vue&type=style&index=0&id=f344eb28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f344eb28",
  null
  
)

export default component.exports